import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'

export function useWorkspaceTasksQuota (
  workspace: string
) {
  const cogfy = useCogfy()

  const getWorkspaceTasksQuota = useQuery({
    queryKey: ['getWorkspaceTasksQuota', workspace],
    queryFn: ({ signal }) => cogfy.getWorkspaceTasksQuota({ signal })
  })

  return getWorkspaceTasksQuota
}
